export default __webpack_public_path__ + "static/media/ic_setting.f9132bdd.svg";